import { RollbackOutlined, SaveOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Button } from 'antd';
import { useEffect, useState } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

export function SpTextEditor({ text = '', onSave = undefined, onCancel = undefined }) {
  const [value, setValue] = useState('');

  const onSaveChange = () => {
    const txt = value.replaceAll('<br />', '\n').replaceAll('<br>', '\n');
    onSave?.(txt);
  };

  useEffect(() => {
    if (text) {
      setValue(text.replaceAll('\n', '<br />'));
    }
  }, [text]);

  return (
    <div>
      <QuillEditor theme="snow" value={value} onChange={setValue} />
      <div style={{ marginTop: 10, width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
        <Button icon={<RollbackOutlined />} onClick={() => onCancel?.()}>
          ยกเลิก
        </Button>
        <Button type="primary" icon={<SaveOutlined />} onClick={onSaveChange}>
          บันทึก
        </Button>
      </div>
    </div>
  );
}

export function stripHtmlTags(html) {
  return html.replace(/<[^>]+>/g, '');
}

const QuillEditor = styled(ReactQuill)({
  '.ql-toolbar.ql-snow': {
    borderColor: '#fff',
    backgroundColor: '#fff',
  },
});
